"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userfrontRoleToUserRole = exports.keycloakRolesToUserRole = exports.keycloakRoleToUserRole = void 0;
const EUserRole_1 = require("../dto/EUserRole");
/**
 * Maps a Keycloak role string to the internal EUserRole enum.
 * Roles come from `resource_access[<backend-client-id>].roles` in the JWT
 * (client roles on the backend client, not realm roles).
 */
function keycloakRoleToUserRole(role) {
    if (role === "admin")
        return EUserRole_1.EUserRole.ADMINISTRATOR;
    return EUserRole_1.EUserRole.ANIMATOR;
}
exports.keycloakRoleToUserRole = keycloakRoleToUserRole;
/**
 * Extracts the highest-priority role from a Keycloak roles array.
 * Admin takes priority over animator.
 */
function keycloakRolesToUserRole(roles) {
    if (roles.includes("admin"))
        return EUserRole_1.EUserRole.ADMINISTRATOR;
    return EUserRole_1.EUserRole.ANIMATOR;
}
exports.keycloakRolesToUserRole = keycloakRolesToUserRole;
// Backward-compatible alias for migration period
const userfrontRoleToUserRole = keycloakRoleToUserRole;
exports.userfrontRoleToUserRole = userfrontRoleToUserRole;
